<template>
  <div>
    <b-row>
      <b-col>
        <!-- <b-list-group>
          <b-list-group-item variant="secondary" v-for="item in this.ListaLicencias" :key="item.Id">
              {{item.TipoLicencia_Id}}
          </b-list-group-item>
        </b-list-group> -->
        <b-list-group>
          <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="item in this.ListaLicenciasGroup" :key="item.Id">
              {{item[0].TipoLicencia.Articulo}} {{item[0].DetalleDiasLicencia.Descripcion}}<b-badge variant="primary" pill>{{item.reduce((accum,item) => accum + item.CantidadDias, 0)}} días</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
var groupBy = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};
import { createHelpers } from 'vuex-map-fields';
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "CardLicenciasSummary",
  mixins: [],
  props: {
  },
  computed:{
    ...mapFormBuscarPersonalFields(['Personal_Id', 'ListaLicencias']),
  ListaLicenciasGroup() {
      console.log('ListaLicenciasGroup', this.ListaLicencias);
      return groupBy(this.ListaLicencias.filter(l => {
        var lDesde = new Date(l.LicenciaDesde);
        console.log('LicenciaDesde', lDesde);
        return lDesde.getFullYear() === this.CurrentYear;
      }), "DetalleDiasLicencia_Id");
    }
  },
  components: { },
  data() {
    return {
      CurrentYear: new Date().getFullYear()
    };
  },
  watch: {
  },
  methods: {
  },
  updated(){
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/CardLicenciasResumen.vue